const visibleParts: Record<string, { label: string; value: string }[]> = {
  hip_joint: [
    {
      label: "Выберите область",
      value: "",
    },
    {
      label: "Левый сустав",
      value: "L",
    },
    {
      label: "Правый сустав",
      value: "R",
    },
    {
      label: "Оба сустава",
      value: "B",
    },
  ],
  spine: [
    {
      label: "Выберите область",
      value: "",
    },
    {
      label: "Шейный отдел",
      value: "N",
    },
    {
      label: "Грудной отдел",
      value: "T",
    },
    {
      label: "Поясничный отдел",
      value: "L",
    },
  ],
};

export default visibleParts;
